let $ = jQuery;
let Hammer = require('hammerjs');
let breakpoints = require('../utilities/breakpoints');

class Tabs {

  constructor($tabs) {
    this.$tabs = $tabs;
    this.length = this.$tabs.find('.tabs-title').length;
    this.$content;

    // The spinner is setup like tabs, but the markup is handled differently.
    if (this.$tabs.attr('id') === 'accessible-tabs-spinner') {
      let $contentWrapper = this.$tabs.parents('.homepage-spinner');
      this.$content = $contentWrapper.find('.tabs-content');
    }
    else {
      this.$content = this.$tabs.parent().find('.tabs-content');
    }

    if (this.$content) {
      this.enableEvents();
    }
  }

  enableEvents() {
    let content = this.$content[0];
    let hammer = new Hammer(content);
    hammer.on('swipeleft', (e) => this.handleSwipeLeft(e));
    hammer.on('swiperight', (e) => this.handleSwipeRight(e));
  }

  handleSwipeLeft(e) {
    if(breakpoints.current == 'small' || breakpoints.current == 'medium') {
      this.next();
    }
  }

  handleSwipeRight(e) {
    if(breakpoints.current == 'small' || breakpoints.current == 'medium') {
      this.previous();
    }
  }

  findCurrent() {
    return this.$tabs.find('.tabs-title.is-active');
  }

  next() {
    this.findCurrent().next('.tabs-title').trigger('click');
  }

  previous() {
    this.findCurrent().prev('.tabs-title').trigger('click');
  }
}

module.exports = {

  attach: function (context, settings) {

    let $tabs = $('.tabs[data-tabs]');
    let list = [];

    $tabs.each((index) => {
      let $item = $tabs.eq(index);
      list.push(new Tabs($item));
    });
  }
};
